import React, { useEffect } from 'react';
import { IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib/dist/components/imForm';
import { observer } from 'mobx-react-lite';
import { useAlliedBrokerPageStore } from 'store/pages/enrollment/broker/broker-allied/pageStore';
import { toJS } from 'mobx';
import { ContentSection } from 'components/common/general/ContentSection';
import { TIN_AND_GA_FORM_ID } from '../constants';
import { FieldsetStyled, IMFormStyled } from './styles';

export const TinAndGaForm: React.FC = observer(() => {
  const {
    tinAndGaDelegate: { form, gaOptions, aorRegion, requestAvailableAgents },
    resetPage,
  } = useAlliedBrokerPageStore();

  useEffect(() => {
    resetPage();
  }, [form.fields.ga.value, form.fields.tin.value]);

  const validationsPassed = form.basicFieldsValidationsPassed;
  const gaValue = form.fields.ga.value;
  const tinValue = form.fields.tin.value;

  useEffect(() => {
    if (validationsPassed && aorRegion && gaValue.length > 0 && tinValue.length > 0) {
      void requestAvailableAgents();
    }
  }, [validationsPassed, gaValue, tinValue]);

  return (
    <ContentSection
      title="Enter Broker Agent TIN & Select General Agency"
      subtitle="We’ll use this information to find agents associated with the TIN"
    >
      <FieldsetStyled disabled={form.isLoading}>
        <IMFormStyled id={TIN_AND_GA_FORM_ID} formController={form}>
          <IMInputText label="Broker TIN" name="tin" $size="full" maxLength={11} />
          <IMSelect
            label="General Agency"
            name="ga"
            $size="full"
            options={gaOptions.slice().map((option) => toJS(option))}
          />
        </IMFormStyled>
      </FieldsetStyled>
    </ContentSection>
  );
});
